export function extractExtensionFromFilename(filename: string): string {
  const data = filename.split(".");
  return data[data.length - 1].toLowerCase();
}

export function shortenFilename(filename: string, maxLength: number): string {
  if (filename.length <= maxLength) {
    return filename;
  }

  const partLength = Math.ceil((maxLength - 3) / 2);
  const startPart = filename.slice(0, partLength);
  const endPart = filename.slice(filename.length - partLength);

  return `${startPart}...${endPart}`;
}
